import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkInputComponent } from './link-input.component';
import { MatFormFieldWrapperModule } from 'src/app/mat-form-field-wrapper/mat-form-field-wrapper.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import {  MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {  MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    LinkInputComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldWrapperModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatIconModule
  ],
  exports: [
    LinkInputComponent
  ]
})
export class LinkInputModule { }
